<div class="container">
  <div class="row">
    <div class="col">
      <div class="my-7 px-4" role="main">
        <div class="text-center">
          <svg
            xmlns:xlink="http://www.w3.org/1999/xlink"
            height="132px"
            version="1.1"
            viewBox="0 0 138 132"
            width="138px"
            xmlns="http://www.w3.org/2000/svg"
          >
            <title>error_pages/icons/security</title>
            <defs>
              <path
                d="M33.7036,0.15716046 C44.8348471,0.15716046 53.9538397,9.20983614 54.1745987,20.3627045 L54.1786933,20.7767209 L54.1791007,38.4791353 C61.7023195,44.5373554 66.5207774,53.8603426 66.5207774,64.3150345 C66.5207774,82.5690383 51.8314514,97.3729802 33.7036,97.3729802 C15.5757486,97.3729802 0.886422564,82.5690383 0.886422564,64.3150345 C0.886422564,53.8603426 5.70488047,44.5373554 13.2280993,38.4791353 L13.2285067,20.7767209 C13.2285067,9.43541778 22.4342548,0.15716046 33.7036,0.15716046 Z M33.7036,35.1770887 C17.7475544,35.1770887 4.80642256,48.2191959 4.80642256,64.3150345 C4.80642256,80.410873 17.7475544,93.4529802 33.7036,93.4529802 C49.6596456,93.4529802 62.6007774,80.410873 62.6007774,64.3150345 C62.6007774,48.2191959 49.6596456,35.1770887 33.7036,35.1770887 Z M33.7036,46.8060616 C39.9023048,46.8060616 44.9211467,51.8640639 44.9211467,58.0958418 C44.9211467,63.6551587 40.9270146,68.2803526 35.6642374,69.2138131 L35.6636,76.7534198 C35.6636,77.8358979 34.7860781,78.7134198 33.7036,78.7134198 C32.6847971,78.7134198 31.8475471,77.9360993 31.7525723,76.9421809 L31.7436,76.7534198 L31.743864,69.213973 C26.4806415,68.2808807 22.4860533,63.655476 22.4860533,58.0958418 C22.4860533,51.8640639 27.5048952,46.8060616 33.7036,46.8060616 Z M33.7036,50.7260616 C29.6767011,50.7260616 26.4060533,54.0222291 26.4060533,58.0958418 C26.4060533,62.1694546 29.6767011,65.4656221 33.7036,65.4656221 L33.6635292,65.464041 C33.6768539,65.4637738 33.6902113,65.4636395 33.7036,65.4636395 L33.7408272,65.4655281 C37.7506368,65.4452883 41.0011467,62.1568943 41.0011467,58.0958418 C41.0011467,54.0222291 37.7304989,50.7260616 33.7036,50.7260616 Z M33.7036,4.07716046 C24.7399118,4.07716046 17.368203,11.3740754 17.1533266,20.3726797 L17.1485067,20.7767209 L17.1483002,35.7655114 C22.0079371,32.8997888 27.6649928,31.2570887 33.7036,31.2570887 C39.7423366,31.2570887 45.3995053,32.8998592 50.2592122,35.7656956 L50.2586933,20.7767209 C50.2586933,11.5929677 42.8005289,4.07716046 33.7036,4.07716046 Z"
                id="path-1"
              ></path>
              <linearGradient id="linearGradient-3" x1="50%" x2="50%" y1="-2.48949813e-15%" y2="100%">
                <stop offset="0%" stop-color="#8017E0"></stop>
                <stop offset="100%" stop-color="#39006B"></stop>
              </linearGradient>
            </defs>
            <g fill="none" fill-rule="evenodd" id="error_pages/icons/security" stroke="none" stroke-width="1">
              <g id="security3" transform="translate(36.000000, 17.000000)">
                <mask fill="white" id="mask-2">
                  <use xlink:href="#path-1"></use>
                </mask>
                <use xlink:href="#path-1" fill="#3E54A4" fill-rule="nonzero" id="Mask"></use>
                <rect
                  fill="url(#linearGradient-3)"
                  height="180.108108"
                  id="primary-gradient-vert"
                  mask="url(#mask-2)"
                  width="185.405405"
                  x="-57.4933333"
                  y="-47.04"
                ></rect>
              </g>
            </g>
          </svg>
        </div>
        <h1 role="heading">We can’t let you in.</h1>
        <h3>You’ll need permission first.</h3>
        <p>
          You’ve attempted to access a restricted area that may require special permission or a subscription. Contact
          your administrator with access questions.
        </p>
        <p class="text-muted mt-4">Error: 403</p>
      </div>
    </div>
  </div>
</div>
